import ValidationRule from './ValidationRule';

class MaxLengthValidationRule extends ValidationRule {
  constructor(message, maxLength) {
    message = (message || '').replace('$maxLength', maxLength);
    super(message);

    this._maxLength = maxLength;
  }

  validate(val) {
    return (val || '').length <= this._maxLength;
  }
}

export default MaxLengthValidationRule;



// WEBPACK FOOTER //
// ./src/common/core/validation/validationRules/MaxLengthValidationRule.js